import React, { useState } from 'react'
import { Button, InputGroup } from "@blueprintjs/core";
import { I18n, Translate } from "react-redux-i18n";
import { useDispatch, useSelector } from 'react-redux';
import { migratingMembers } from '../../store/my_circles/selectors';
import { migrateMembers } from '../../store/my_circles/operations';
import { fetchCircle } from "../../store/my_circles/operations";

export default function MigrateCircleMembers({ circle }) {
    const loading = useSelector(migratingMembers);
    const [source_circle_guid, setSourceGuid] = useState('');
    const dispatch = useDispatch();
    const copyMembers = (e) => {
        e.preventDefault();
        const source_guid = source_circle_guid.trim();
        if (source_guid.length > 30 && !loading) {
            const payload = {
                source_circle_guid: source_guid,
                destination_circle_guid: circle.guid
            }
            dispatch(migrateMembers(payload, fetchCircle(circle.guid, true)));
        }
    }

    return (
        <div className="custom-card">
            <h1 className="bp3-heading">
                <Translate value="circle_members.migrate_members" />
            </h1>
            <form onSubmit={copyMembers}>
                <InputGroup
                    id="reason"
                    type="text"
                    value={source_circle_guid}
                    placeholder={I18n.t("circle_members.source_circle")}
                    fill={true}
                    onChange={event => setSourceGuid(event.target.value)}
                    className="split-item no-icon has-button primary-button two-thirds"
                    rightElement={
                        <Button onClick={copyMembers} intent="primary" type='submit' icon="import" loading={loading} disabled={loading} />
                    }
                />
            </form>
        </div>
    )
}
